import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import FilterCustom from "./Filter"
import PurchaseDetailModal from "../Modal/DetailModal"
import { set } from "lodash"

function ListPurchase({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  setExcelKeyword,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setExcelKeyword(keyword)
    try {
      const res = await ReportsService.getReportAgencyPurchase({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        // console.log("API trả về:", res.success.data);
        const formatted = res?.success?.data.map((item, index) => ({
          ...item,
          ID: item.ID,
          key: item.ID || index,
          export_id: item.export?.ID || "",
          order_code: item.export_code || "",
          customer_name: item.customer?.fullname || "",
          total_sim: item.sim_quantity || 0,
          update_at: item.approved_export_at || "",
          approved_export_by: item.approved_export_by?.fullname || "",
          price: item.total_discount ? Number(item.total_discount) : 0,
          total_price: item.total_amount ? Number(item.total_amount) : 0,
          sim_type: item.sim_type == 1 ? "Sim vật lý" : "E-SIM",
        }))

        setDataSource(formatted)
        setSummary({
          total_quantity: Number(
            res?.success?.sim?.total_sim || 0,
          ).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
          total_unit_price: Number(
            res?.success?.sim?.total_amount || 0,
          ).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
          total_end_price: Number(
            res?.success?.sim?.total_discount || 0,
          ).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
          usim: Number(res?.success?.sim?.usim || 0),
          esim: Number(res?.success?.sim?.esim || 0),
        })

        setPagination({
          ...pagination,
          total: res?.success?.total || 0,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      // Thêm điều kiện kiểm tra để không gọi API ở lần render đầu tiên
      // vì useEffect trên đã xử lý việc đó.
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [filter, keyword, tabStatus, refresh])

  useEffect(() => {
    setParentFilter(filter)
  }, [filter, setParentFilter])

  const columns = [
    // {
    //   title: "STT",
    //   dataIndex: "index",
    //   key: "index",
    //   align: "center",
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1,
    //   width: 60,
    // },
    {
      title: "Đơn hàng",
      dataIndex: "order_code",
      key: "order_code",
      align: "center",
    },
    {
      title: "Khách hàng",
      dataIndex: "customer_name",
      key: "customer_name",
      align: "center",
    },
    {
      title: "Tổng số SIM",
      dataIndex: "total_sim",
      key: "total_sim",
      align: "center",
    },
    {
      title: "Loại SIM",
      dataIndex: "sim_type",
      key: "sim_type",
      align: "center",
    },
    {
      title: "Giá nhập",
      dataIndex: "total_price",
      key: "total_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
      render: value =>
        value ? new Intl.NumberFormat().format(Number(value)) : "",
    },
    // {
    //   title: "Giá sau chiết khấu",
    //   dataIndex: "price",
    //   key: "price",
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    //   render: value =>
    //     value ? new Intl.NumberFormat().format(Number(value)) : "",
    // },
    {
      title: "Ngày duyệt nhập kho",
      dataIndex: "update_at",
      key: "update_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    {
      title: "Người duyệt nhập kho",
      dataIndex: "approved_export_by",
      key: "approved_export_by",
      align: "center",
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  const handleRowClick = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false)
    setSelectedRecord(null)
  }
  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số SIM: {summary?.total_quantity}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>Tổng tiền nhập: {summary.total_unit_price}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>SIM vật lý: {summary.usim} SIM</strong>
        </div>
        <div
          style={{ padding: "0 5px", color: "#3e3f42ff", minWidth: "150px" }}
        >
          <strong>E-SIM: {summary.esim} SIM</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              handleRowClick(record?.ID)
            },
          }
        }}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {selectedRecord && (
        <PurchaseDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseDetailModal}
          recordId={selectedRecord}
        />
      )}
    </div>
  )
}

export default ListPurchase
